import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=24025354&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=24025354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24025354",
  null
  
)

export default component.exports